import React from 'react'
import Icon from "./../static/icon"
import styles from "./radioCheckButtonfirstQuestionB.module.scss"

const radioCheckButtonfirstQuestionB = props => {
  const { isChecked, onClick, image, title } = props;

  return (
    <button className={`${isChecked ? styles.radioCheckButtonBChecked : styles.radioCheckButtonB} `} onClick={onClick}>
      <div className={styles.firstPageQuestionB_img}>
        <img src={image}/> 
      </div>
      <div className={styles.firstPageQuestionB_text}>
        <div>{title}</div>
      </div>
    </button>
  )
}

export default React.memo(radioCheckButtonfirstQuestionB)